/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileCardSchemaCriteriaBand = typeof ProfileCardSchemaCriteriaBand[keyof typeof ProfileCardSchemaCriteriaBand] | null;


export const ProfileCardSchemaCriteriaBand = {
  good: 'good',
  partial: 'partial',
  bad: 'bad',
} as const;
